import $ from 'jquery'
import { lockBody, unlockBody } from './utils'

$('.js-open-algolia').on('click', function () {
  $('.site-header__algolia-input').css('visibility', 'hidden')
  $('body').addClass('search-active')
  lockBody()
  setTimeout(function () {
    $('.js-algolia-search-input').focus()
  }, 500)
})

$('.js-close-algolia').on('click', function () {
  $('.site-header__algolia-input').css('visibility', 'visible')
  $('body').removeClass('search-active')
  unlockBody()
})

$('.search-entry').on('click', function (e) {
  if (e.target === this && window.matchMedia('(min-width: 992px)').matches) {
    $('.site-header__algolia-input').css('visibility', 'visible')
    $('body').removeClass('search-active')
    unlockBody()
  }
})
